module.exports = __webpack_public_path__ + "static/media/bgm.9a6735fb.mp3";